import itemsSubcategory from '../stips/category/itemsSubcategory';

// Sajt je samo na srpskom: parametar `lang` se zadržava zbog postojećih poziva, ali se ne koristi.
export default class TypeIcludes{
  static convert(description,type,lang){
    return this.srFind(description,type);
  }
  static srFind(description,type){
    let res = description.split('pijacama')[0].split('-').join(' ') + 'pijacama';
    let find  = itemsSubcategory.subcategory.filter(x=> x.description_path.toLowerCase() == res)

    if(find.length > 0){
       return type == 1 ?  find[0].value : find[0].value_path;
    }
    return ''

  }
}
